
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec702"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec702"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bgeJJ", function(module, exports) {

var $jJTNo = parcelRequire("jJTNo");

var $d1EmY = parcelRequire("d1EmY");

var $4PA3H = parcelRequire("4PA3H");

var $bXxxB = parcelRequire("bXxxB");

var $33JxX = parcelRequire("33JxX");

var $gkar0 = parcelRequire("gkar0");

var $7eR2O = parcelRequire("7eR2O");
class $e79202f3391f2c44$var$NavBar extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: 'open'
        });
    }
    static get observedAttributes() {
        return [
            'mainText'
        ];
    }
    get mainText() {
        return this.getAttribute('mainText');
    }
    set mainText(value) {
        this.setAttribute('mainText', value);
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.render();
        // Attach events directly after first render
        const navToggle = this.shadow.querySelector('.nav-toggle');
        const navMenu = this.shadow.querySelector('.nav-menu');
        const logo = this.shadow.querySelector('.logo');
        const notesContainer = this.shadow.querySelector('.logo-notes');
        if (navToggle && navMenu) navToggle.addEventListener('click', ()=>{
            const isOpen = navMenu.classList.toggle('open');
            navToggle.classList.toggle('open', isOpen);
            navToggle.setAttribute('aria-expanded', String(isOpen));
        });
        if (logo && notesContainer) {
            // ♫ ♪ ♬ ♩ ♯ ♭
            const notes = [
                '\u266B',
                '\u266A',
                '\u266C',
                '\u2669',
                '\u266F',
                '\u266D'
            ];
            logo.addEventListener('mouseenter', ()=>{
                for(let i = 0; i < 3; i++){
                    const note = document.createElement('span');
                    note.className = 'logo-note';
                    note.textContent = notes[Math.floor(Math.random() * notes.length)];
                    note.style.left = `${40 + i * 20 - Math.random() * 20}px`;
                    note.style.animationDelay = `${i * 0.12 + Math.random() * 0.08}s`;
                    notesContainer.appendChild(note);
                    note.addEventListener('animationend', ()=>note.remove(), {
                        once: true
                    });
                }
            });
        }
    }
    render() {
        const homeClass = this.mainText === 'home' ? 'active' : '';
        const aboutClass = this.mainText === 'about' ? 'active' : '';
        const bioClass = this.mainText === 'bio' ? 'active' : '';
        const template = (0, $jJTNo.html)`
      <link href="${$d1EmY}" rel="stylesheet" />
      <link href="${$4PA3H}" rel="stylesheet" />
      <link href="${$bXxxB}" rel="stylesheet" />
      <header>
        <nav class="navbar">
          <div class="container">
            <a href="/" class="logo" aria-label="Home">
              <img src="${$33JxX}" alt="Dan’s Music Lessons Logo" />
              <span class="logo-notes"></span>
            </a>
            <button
              class="nav-toggle"
              aria-label="Toggle navigation"
              aria-expanded="false"
              aria-controls="nav-menu"
            >
              <img src="${$gkar0}" alt="Menu" class="hamburger-icon" />
              <img src="${$7eR2O}" alt="G Clef" class="gclef-icon" />
            </button>
            <ul class="nav-menu" id="nav-menu">
              <li><a href="/" class="${homeClass} frijole-regular">Home</a></li>
              <li>
                <a href="/about" class="${aboutClass} frijole-regular"
                  >Lessons/ Sign Up</a
                >
              </li>
              <li>
                <a href="/bio" class="${bioClass} frijole-regular">Bio</a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    `;
        (0, $jJTNo.render)(template, this.shadow);
    }
}
customElements.define('nav-bar', $e79202f3391f2c44$var$NavBar);

});
parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.1");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("d1EmY", function(module, exports) {
module.exports = import.meta.resolve("fLoJN");

});

parcelRegister("4PA3H", function(module, exports) {
module.exports = import.meta.resolve("iVnRt");

});

parcelRegister("bXxxB", function(module, exports) {
module.exports = import.meta.resolve("bFBXe");

});

parcelRegister("33JxX", function(module, exports) {
module.exports = import.meta.resolve("90mMd");

});

parcelRegister("gkar0", function(module, exports) {
module.exports = import.meta.resolve("dZMbQ");

});

parcelRegister("7eR2O", function(module, exports) {
module.exports = import.meta.resolve("lDh0b");

});


parcelRegister("l2CVb", function(module, exports) {

var $jJTNo = parcelRequire("jJTNo");

var $d1EmY = parcelRequire("d1EmY");

var $4PA3H = parcelRequire("4PA3H");

var $270vj = parcelRequire("270vj");

var $haOex = parcelRequire("haOex");

var $ld1iS = parcelRequire("ld1iS");
class $a1d1a27758b5ff9c$var$CustomFooter extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: 'open'
        });
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const template = (0, $jJTNo.html)`
      <link href="${$d1EmY}" rel="stylesheet" />
      <link href="${$270vj}" rel="stylesheet" />
      <link href="${$4PA3H}" rel="stylesheet" />
      <footer class="footer">
        <div class="container">
          <p class="copyright">&copy; 2025 Dan’s Music Lessons. All rights reserved.</p>
          <div class="contact-lines">
            <p class="contact-item">
              Email:
              <a href="mailto:danieljsitar@gmail.com">danieljsitar@gmail.com</a>
            </p>
            <p class="contact-item">
              Phone:
              <a href="tel:+19783027411">(978) 302-7411</a>
            </p>
            <p class="contact-item legal-links">
              <strong>Legal:</strong>
              <a href="/privacy">Privacy Policy</a>
              <span aria-hidden="true"> / </span>
              <a href="/tos">Terms of Service</a>
            </p>
          </div>
          <div class="social">
            <a
              href="https://www.instagram.com/dansitar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <img src="${$haOex}" alt="Instagram" class="social-icon ig" />
            </a>
            <a
              href="https://www.youtube.com/@dansitar1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <img src="${$ld1iS}" alt="YouTube" class="social-icon yt" />
            </a>
          </div>
          <div class="design-by">
            Designed by
            <a
              class="ethnocentric-regular"
              href="https://brainedge.llc"
              target="_blank"
              >Brain Edge</a
            >
          </div>
        </div>
      </footer>
    `;
        (0, $jJTNo.render)(template, this.shadow);
    }
}
customElements.define('custom-footer', $a1d1a27758b5ff9c$var$CustomFooter);

});
parcelRegister("270vj", function(module, exports) {
module.exports = import.meta.resolve("ewn1g");

});

parcelRegister("haOex", function(module, exports) {
module.exports = import.meta.resolve("gjzVs");

});

parcelRegister("ld1iS", function(module, exports) {
module.exports = import.meta.resolve("1n717");

});


parcelRegister("fvzOd", function(module, exports) {

var $jJTNo = parcelRequire("jJTNo");

var $jZBbb = parcelRequire("jZBbb");

var $d1EmY = parcelRequire("d1EmY");

var $4PA3H = parcelRequire("4PA3H");

var $2GcrT = parcelRequire("2GcrT");
class $7620ee389a03f081$var$SignUp extends HTMLElement {
    static fallbackEmail = 'danieljsitar@gmail.com';
    static fallbackPhoneDisplay = '(978) 302-7411';
    static fallbackPhoneLink = '+19783027411';
    static defaultEmailJsConfig = Object.freeze({
        serviceId: 'service_7016i18',
        templateId: 'template_3r56m5k',
        publicKey: 'upWPh-GuDqJV6xAEY'
    });
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: 'open'
        });
        this.onDocClick = this.onDocClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onPopupClose = this.onPopupClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    connectedCallback() {
        this.render();
        this.cacheEls();
        this.attachEvents();
        this.initLogoNotes();
    }
    disconnectedCallback() {
        this.detachEvents();
        if (this._notesTimer) clearInterval(this._notesTimer);
        this.clearPopupTimer();
        this.clearCloseTimer();
    }
    render() {
        const template = (0, $jJTNo.html)`
      <link href="${$d1EmY}" rel="stylesheet" />
      <link href="${$4PA3H}" rel="stylesheet" />
      <link href="${$2GcrT}" rel="stylesheet" />

      <button
        id="contact-slide-toggle"
        aria-haspopup="dialog"
        aria-expanded="false"
        class="frijole-regular"
      >
        ${this.getAttribute('button-label') || 'Sign Up'}
        <!-- Notes animation -->
        <span class="logo-notes"></span>
      </button>

      <aside
        id="contact-slide-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-form-title"
      >
        <button
          id="contact-slide-close"
          aria-label="Close sign-up form"
          type="button"
        >
          &times;
        </button>

        <form id="contact-form" class="form-card" novalidate>
          <h2 id="contact-form-title" class="frijole-regular">Quick Sign-Up</h2>
          <div class="quick-contact-links">
            <p class="quick-contact-item">
              Prefer email?
              <a href="mailto:${$7620ee389a03f081$var$SignUp.fallbackEmail}">${$7620ee389a03f081$var$SignUp.fallbackEmail}</a>
            </p>
            <p class="quick-contact-item">
              Prefer phone?
              <a href="tel:${$7620ee389a03f081$var$SignUp.fallbackPhoneLink}">${$7620ee389a03f081$var$SignUp.fallbackPhoneDisplay}</a>
            </p>
          </div>

          <div class="form-grid">
            <div class="field">
              <label for="name">Name:</label>
              <input type="text" id="name" name="name" autocomplete="name" />
            </div>

            <div class="field">
              <label>What would you like to study:</label>
              <div class="study-bubbles" data-hidden="#study" data-multi="true">
                <button type="button" class="study-bubble" data-value="guitar">
                  Guitar
                </button>
                <button type="button" class="study-bubble" data-value="piano">
                  Piano
                </button>
                <button type="button" class="study-bubble" data-value="drums">
                  Drums
                </button>
                <button type="button" class="study-bubble" data-value="bass">
                  Bass
                </button>
                <button
                  type="button"
                  class="study-bubble"
                  data-value="recording"
                >
                  Recording
                </button>
                <button
                  type="button"
                  class="study-bubble"
                  data-value="production"
                >
                  Production
                </button>
                <button type="button" class="study-bubble" data-value="mixing">
                  Mixing
                </button>
                <button
                  type="button"
                  class="study-bubble"
                  data-value="mastering"
                >
                  Mastering
                </button>
                <button
                  type="button"
                  class="study-bubble"
                  data-value="music theory"
                >
                  Music Theory
                </button>
                <button
                  type="button"
                  class="study-bubble"
                  data-value="songwriting"
                >
                  Songwriting
                </button>
              </div>
              <input type="hidden" id="study" name="study" value="" />
            </div>

            <div class="field">
              <label for="experience">How much experience do you have:</label>
              <input
                type="text"
                id="experience"
                name="experience"
                autocomplete="off"
              />
            </div>

            <div class="field">
              <label for="email"
                >E-mail address: <span class="required">*</span></label
              >
              <input
                type="email"
                id="email"
                name="email"
                required
                autocomplete="email"
              />
            </div>

            <div class="field">
              <label for="genres">Genres you’re into:</label>
              <input type="text" id="genres" name="genres" autocomplete="off" />
            </div>

            <div class="field">
              <label for="goals">Your goals:</label>
              <textarea id="goals" name="goals"></textarea>
            </div>

            <div class="field">
              <label>Days available:</label>
              <div
                class="days-bubbles"
                data-hidden="#day"
                data-multi="true"
                data-sync-pill="day"
              >
                <button type="button" class="days-bubble" data-value="Monday">
                  Monday
                </button>
                <button type="button" class="days-bubble" data-value="Tuesday">
                  Tuesday
                </button>
                <button
                  type="button"
                  class="days-bubble"
                  data-value="Wednesday"
                >
                  Wednesday
                </button>
                <button type="button" class="days-bubble" data-value="Thursday">
                  Thursday
                </button>
              </div>
              <input type="hidden" id="day" name="day" value="" />
            </div>

            <div class="field">
              <label for="time">Times available (1 PM ET – 9 PM ET):</label>
              <input type="text" id="time" name="time" autocomplete="off" />
            </div>

            <div class="field">
              <label>Lesson length:</label>
              <div class="length-bubbles" data-hidden="#length">
                <button type="button" class="length-bubble" data-value="30 min">
                  30 mins
                </button>
                <button type="button" class="length-bubble" data-value="45 min">
                  45 mins
                </button>
                <button type="button" class="length-bubble" data-value="60 min">
                  60 mins
                </button>
              </div>
              <input type="hidden" id="length" name="length" value="" />
            </div>

            <div class="field">
              <label>Lesson recurrence:</label>
              <div class="recurrence-bubbles" data-hidden="#recurrence">
                <button
                  type="button"
                  class="recurrence-bubble"
                  data-value="Single"
                >
                  Single
                </button>
                <button
                  type="button"
                  class="recurrence-bubble"
                  data-value="Weekly"
                >
                  Weekly
                </button>
              </div>
              <input type="hidden" id="recurrence" name="recurrence" value="" />
            </div>

            <div class="field">
              <label for="referral">How’d you hear about me?</label>
              <input
                type="text"
                id="referral"
                name="referral"
                autocomplete="off"
              />
            </div>

            <div class="field checkbox-field full-span">
              <input
                type="checkbox"
                id="age_confirm"
                name="age_confirm"
                required
              />
              <label for="age_confirm"
                >Student is over 6 years of age
                <span class="required">*</span></label
              >
            </div>

            <div class="field full-span">
              <label for="additional">Anything else:</label>
              <textarea id="additional" name="additional"></textarea>
            </div>
          </div>

          <button type="submit" class="btn full-span">Submit</button>
        </form>
      </aside>
      <div id="contact-popup" class="contact-popup" hidden>
        <div
          id="contact-popup-card"
          class="contact-popup-card"
          role="status"
          aria-live="polite"
        >
          <span id="contact-popup-icon" class="popup-icon" aria-hidden="true"
            >!</span
          >
          <div class="popup-copy">
            <p id="contact-popup-title" class="popup-title"></p>
            <p id="contact-popup-text" class="popup-text"></p>
          </div>
          <button
            id="contact-popup-close"
            type="button"
            class="popup-close"
            aria-label="Dismiss message"
          >
            x
          </button>
        </div>
      </div>
    `;
        (0, $jJTNo.render)(template, this.shadow);
    }
    cacheEls() {
        this.$toggle = this.shadow.getElementById('contact-slide-toggle');
        this.$panel = this.shadow.getElementById('contact-slide-panel');
        this.$close = this.shadow.getElementById('contact-slide-close');
        this.$form = this.shadow.getElementById('contact-form');
        this.$notesHost = this.$toggle.querySelector('.logo-notes');
        this.$popup = this.shadow.getElementById('contact-popup');
        this.$popupCard = this.shadow.getElementById('contact-popup-card');
        this.$popupIcon = this.shadow.getElementById('contact-popup-icon');
        this.$popupTitle = this.shadow.getElementById('contact-popup-title');
        this.$popupText = this.shadow.getElementById('contact-popup-text');
        this.$popupClose = this.shadow.getElementById('contact-popup-close');
    }
    attachEvents() {
        this.$toggle.addEventListener('click', this.onToggle);
        this.$close.addEventListener('click', this.onClose);
        this.shadow.querySelectorAll('.study-bubbles, .length-bubbles, .recurrence-bubbles, .days-bubbles').forEach((group)=>group.addEventListener('click', (e)=>this.onBubbleClick(e, group)));
        this.$form.addEventListener('submit', this.onSubmit);
        this.$popupClose?.addEventListener('click', this.onPopupClose);
        document.addEventListener('click', this.onDocClick, true);
        document.addEventListener('keydown', this.onKeyDown, true);
    }
    detachEvents() {
        this.$toggle?.removeEventListener('click', this.onToggle);
        this.$close?.removeEventListener('click', this.onClose);
        this.$form?.removeEventListener('submit', this.onSubmit);
        this.$popupClose?.removeEventListener('click', this.onPopupClose);
        document.removeEventListener('click', this.onDocClick, true);
        document.removeEventListener('keydown', this.onKeyDown, true);
    }
    // Panel
    open() {
        this.$panel.classList.add('open');
        this.$toggle.setAttribute('aria-expanded', 'true');
        queueMicrotask(()=>this.shadow.getElementById('name')?.focus());
    }
    close() {
        this.$panel.classList.remove('open');
        this.$toggle.setAttribute('aria-expanded', 'false');
        this.hidePopup({
            immediate: true
        });
    }
    onToggle() {
        this.$panel.classList.contains('open') ? this.close() : this.open();
    }
    onClose() {
        this.close();
    }
    onPopupClose() {
        this.hidePopup();
    }
    onDocClick(e) {
        const path = e.composedPath?.() || [];
        if (!path.includes(this.$panel) && !path.includes(this.$toggle)) this.close();
    }
    onKeyDown(e) {
        if (e.key === 'Escape' && this.$panel.classList.contains('open')) this.close();
    }
    // Bubbles (supports single + multi, and optional day-pill mirroring)
    onBubbleClick(e, group) {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;
        const multi = group.dataset.multi === 'true';
        const hidden = group.dataset.hidden ? this.shadow.querySelector(group.dataset.hidden) : null;
        if (!hidden) return;
        if (multi) {
            btn.classList.toggle('selected');
            const values = [
                ...group.querySelectorAll('button.selected')
            ].map((b)=>b.dataset.value);
            hidden.value = values.join(', ');
        } else {
            group.querySelectorAll('button.selected').forEach((b)=>b.classList.remove('selected'));
            if (!btn.classList.contains('selected')) {
                btn.classList.add('selected');
                hidden.value = btn.dataset.value;
            } else hidden.value = '';
        }
        if (group.dataset.syncPill === 'day') {
            const val = btn.dataset.value;
            const pills = document.querySelectorAll(`.day-pill[data-day="${val}"]`);
            pills.forEach((p)=>p.classList.toggle('active', btn.classList.contains('selected')));
        }
    }
    getEmailJsConfig() {
        const getAttr = (name)=>{
            const value = this.getAttribute(name);
            if (typeof value !== 'string') return '';
            return value.trim();
        };
        const globalConfig = window.__EMAILJS_CONFIG__ || {};
        const config = {
            serviceId: getAttr('emailjs-service-id') || globalConfig.serviceId || $7620ee389a03f081$var$SignUp.defaultEmailJsConfig.serviceId,
            templateId: getAttr('emailjs-template-id') || globalConfig.templateId || $7620ee389a03f081$var$SignUp.defaultEmailJsConfig.templateId,
            publicKey: getAttr('emailjs-public-key') || globalConfig.publicKey || $7620ee389a03f081$var$SignUp.defaultEmailJsConfig.publicKey
        };
        const missing = Object.entries(config).filter(([, value])=>!value).map(([key])=>key);
        if (missing.length) {
            console.warn(`Missing EmailJS configuration keys: ${missing.join(', ')}`);
            return null;
        }
        return config;
    }
    // Submit via EmailJS
    async onSubmit(e) {
        e.preventDefault();
        this.hidePopup({
            immediate: true
        });
        const email = this.shadow.getElementById('email');
        const age = this.shadow.getElementById('age_confirm');
        if (!email.checkValidity() || !age.checked) {
            email.reportValidity?.();
            if (!age.checked) this.shadow.getElementById('age_confirm')?.focus();
            return;
        }
        const submitBtn = this.$form.querySelector('.btn');
        submitBtn.disabled = true;
        const payload = Object.fromEntries(new FormData(this.$form).entries());
        try {
            const emailJsConfig = this.getEmailJsConfig();
            if (!emailJsConfig) throw new Error('EmailJS configuration is missing.');
            await (0, $jZBbb.default).sendForm(emailJsConfig.serviceId, emailJsConfig.templateId, this.$form, {
                publicKey: emailJsConfig.publicKey
            });
            this.showEmojiConfetti(submitBtn);
            this.showSubmitPopup({
                title: 'Thanks, your message was sent',
                text: 'We received your sign-up and will follow up soon.',
                type: 'success'
            });
            this.resetForm();
            this.clearCloseTimer();
            this._closeTimer = setTimeout(()=>this.close(), 1800);
        } catch (err) {
            console.error('Submit error:', err);
            this.showSubmitPopup({
                title: 'Message ready to send',
                text: 'We opened your email app with your details prefilled. Please review and tap send.',
                type: 'fallback'
            });
            this.openFallbackEmail(payload);
        } finally{
            submitBtn.disabled = false;
        }
    }
    buildFallbackEmailBody(payload) {
        const getValue = (key)=>{
            if (key === 'age_confirm') return payload[key] === 'on' ? 'Yes' : 'No';
            const value = payload[key];
            if (typeof value !== 'string') return "\u2014";
            const trimmed = value.trim();
            return trimmed || "\u2014";
        };
        const fields = [
            [
                'Name',
                'name'
            ],
            [
                'Email',
                'email'
            ],
            [
                'Wants to study',
                'study'
            ],
            [
                'Experience',
                'experience'
            ],
            [
                'Genres',
                'genres'
            ],
            [
                'Goals',
                'goals'
            ],
            [
                'Days available',
                'day'
            ],
            [
                'Times available',
                'time'
            ],
            [
                'Lesson length',
                'length'
            ],
            [
                'Recurrence',
                'recurrence'
            ],
            [
                'Referral',
                'referral'
            ],
            [
                'Student over 6',
                'age_confirm'
            ],
            [
                'Additional notes',
                'additional'
            ]
        ];
        return [
            'Website form delivery failed, so I am sending this directly from my email app.',
            '',
            ...fields.map(([label, key])=>`${label}: ${getValue(key)} /`)
        ].join('\n');
    }
    openFallbackEmail(payload) {
        const name = (payload.name || '').trim();
        const subject = name ? `Lesson Sign-Up (Fallback): ${name}` : 'Lesson Sign-Up (Fallback)';
        const body = this.buildFallbackEmailBody(payload);
        const mailto = `mailto:${$7620ee389a03f081$var$SignUp.fallbackEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailto;
    }
    clearPopupTimer() {
        if (this._popupTimer) {
            clearTimeout(this._popupTimer);
            this._popupTimer = null;
        }
    }
    clearCloseTimer() {
        if (this._closeTimer) {
            clearTimeout(this._closeTimer);
            this._closeTimer = null;
        }
    }
    showSubmitPopup({ title: title, text: text, type: type = 'fallback' }) {
        if (!this.$popup || !this.$popupCard || !this.$popupTitle || !this.$popupText) return;
        this.clearPopupTimer();
        this.$popupCard.classList.remove('popup-fallback', 'popup-success');
        this.$popupCard.classList.add(`popup-${type}`);
        if (this.$popupIcon) this.$popupIcon.textContent = type === 'success' ? "\u2713" : '!';
        this.$popupTitle.textContent = title;
        this.$popupText.textContent = text;
        this.$popup.hidden = false;
        requestAnimationFrame(()=>this.$popup.classList.add('show'));
        this._popupTimer = setTimeout(()=>this.hidePopup(), 7000);
    }
    hidePopup({ immediate: immediate = false } = {}) {
        if (!this.$popup || !this.$popupCard) return;
        this.clearPopupTimer();
        if (immediate || !this.$popup.classList.contains('show')) {
            this.$popup.classList.remove('show');
            this.$popupCard.classList.remove('popup-fallback', 'popup-success');
            this.$popup.hidden = true;
            return;
        }
        this.$popup.classList.remove('show');
        setTimeout(()=>{
            if (!this.$popup.classList.contains('show')) this.$popup.hidden = true;
        }, 240);
    }
    resetForm() {
        this.$form.reset();
        this.shadow.querySelectorAll('.selected').forEach((el)=>el.classList.remove('selected'));
        // Clear hidden inputs
        [
            'study',
            'day',
            'length',
            'recurrence'
        ].forEach((id)=>{
            const el = this.shadow.getElementById(id);
            if (el) el.value = '';
        });
        document.querySelectorAll('.day-pill.active').forEach((p)=>p.classList.remove('active'));
    }
    // Floating Notes
    initLogoNotes() {
        const notesPool = [
            '\u266B',
            '\u266A',
            '\u266C',
            '\u2669',
            '\u266F',
            '\u266D'
        ];
        const host = this.$notesHost;
        if (!host) return;
        const createNotes = ()=>{
            // Create a short burst of notes
            for(let i = 0; i < 6; i++){
                const note = document.createElement('span');
                note.className = 'logo-note';
                note.textContent = notesPool[Math.floor(Math.random() * notesPool.length)];
                note.style.left = `${40 + i * 20 - Math.random() * 20}px`;
                note.style.animationDelay = `${i * 0.12 + Math.random() * 0.08}s`;
                host.appendChild(note);
                note.addEventListener('animationend', ()=>note.remove());
            }
        };
        createNotes();
        this._notesTimer = setInterval(createNotes, 5000);
    }
    // Emoji confetti
    showEmojiConfetti(targetBtn) {
        const emojis = [
            "\uD83C\uDFB5",
            "\uD83C\uDFB6",
            "\uD83C\uDFBC",
            "\uD83C\uDFA4",
            "\uD83C\uDFB9",
            "\uD83E\uDD41",
            "\uD83C\uDFB7",
            "\uD83C\uDFBA",
            "\uD83E\uDE97",
            "\uD83E\uDE95"
        ];
        const rect = targetBtn.getBoundingClientRect();
        for(let i = 0; i < 28; i++){
            const emoji = document.createElement('span');
            emoji.textContent = emojis[Math.floor(Math.random() * emojis.length)];
            Object.assign(emoji.style, {
                position: 'fixed',
                left: rect.left + rect.width / 2 + 'px',
                top: rect.top + rect.height / 2 + 'px',
                fontSize: `${2 + Math.random() * 2.5}rem`,
                fontFamily: `'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji',sans-serif`,
                pointerEvents: 'none',
                zIndex: 9999,
                transition: 'transform 2.4s cubic-bezier(0.18, 0.7, 0.32, 1), opacity 2.4s',
                textShadow: '0 2px 8px #fff, 0 1px 0 #fff'
            });
            document.body.appendChild(emoji);
            const angle = -Math.PI / 2 + (Math.random() - 0.5) * (Math.PI / 2);
            const distance = 700 + Math.random() * 400;
            const x = Math.cos(angle) * distance;
            const y = Math.sin(angle) * distance;
            setTimeout(()=>{
                emoji.style.transform = `translate(${x}px, ${y}px) scale(${0.8 + Math.random() * 1.2}) rotate(${Math.random() * 2160}deg)`;
                emoji.style.opacity = 0;
            }, 10);
            setTimeout(()=>emoji.remove(), 2500);
        }
    }
}
customElements.define('sign-up', $7620ee389a03f081$var$SignUp);

});
parcelRegister("jZBbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e08de5e84870c6$export$2e2bcd8739ae039);

var $4Fcgk = parcelRequire("4Fcgk");

var $734Vz = parcelRequire("734Vz");

var $6HKb6 = parcelRequire("6HKb6");

var $6nwiP = parcelRequire("6nwiP");
var $e8e08de5e84870c6$export$2e2bcd8739ae039 = {
    init: $734Vz.init,
    send: $6HKb6.send,
    sendForm: $6nwiP.sendForm,
    EmailJSResponseStatus: $4Fcgk.EmailJSResponseStatus
};

});
parcelRegister("4Fcgk", function(module, exports) {

$parcel$export(module.exports, "EmailJSResponseStatus", () => $365480cad2bbacec$export$29b488039e3d4c2d);
class $365480cad2bbacec$export$29b488039e3d4c2d {
    constructor(_status = 0, _text = 'Network Error'){
        this.status = _status;
        this.text = _text;
    }
}

});

parcelRegister("734Vz", function(module, exports) {

$parcel$export(module.exports, "init", () => $521ca2b4a362b637$export$2cd8252107eb640b);

var $h8rc9 = parcelRequire("h8rc9");

var $ZpNu1 = parcelRequire("ZpNu1");
const $521ca2b4a362b637$export$2cd8252107eb640b = (options, origin = 'https://api.emailjs.com')=>{
    if (!options) return;
    const opts = (0, $ZpNu1.buildOptions)(options);
    (0, $h8rc9.store).publicKey = opts.publicKey;
    (0, $h8rc9.store).blockHeadless = opts.blockHeadless;
    (0, $h8rc9.store).storageProvider = opts.storageProvider;
    (0, $h8rc9.store).blockList = opts.blockList;
    (0, $h8rc9.store).limitRate = opts.limitRate;
    (0, $h8rc9.store).origin = opts.origin || origin;
};

});
parcelRegister("h8rc9", function(module, exports) {

$parcel$export(module.exports, "store", () => $c798475fc5eb7ae4$export$6f57813fe9f31bf9);

var $qQ4zJ = parcelRequire("qQ4zJ");
const $c798475fc5eb7ae4$export$6f57813fe9f31bf9 = {
    origin: 'https://api.emailjs.com',
    blockHeadless: false,
    storageProvider: (0, $qQ4zJ.createWebStorage)()
};

});
parcelRegister("qQ4zJ", function(module, exports) {

$parcel$export(module.exports, "createWebStorage", () => $050ad26521b99438$export$2b84f07db8df86ee);
const $050ad26521b99438$export$2b84f07db8df86ee = ()=>{
    if (typeof localStorage === 'undefined') return;
    return {
        get: (key)=>Promise.resolve(localStorage.getItem(key)),
        set: (key, value)=>Promise.resolve(localStorage.setItem(key, value)),
        remove: (key)=>Promise.resolve(localStorage.removeItem(key))
    };
};

});


parcelRegister("ZpNu1", function(module, exports) {

$parcel$export(module.exports, "buildOptions", () => $0b89b563b8ce5c16$export$ecbd7d678ac4909b);
const $0b89b563b8ce5c16$export$ecbd7d678ac4909b = (options)=>{
    if (!options) return {};
    // support compatibility with SDK v3
    if (typeof options === 'string') return {
        publicKey: options
    };
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (options.toString() === '[object Object]') return options;
    return {};
};

});


parcelRegister("6HKb6", function(module, exports) {

$parcel$export(module.exports, "send", () => $4e1a944052b5621b$export$89db4734f6c919c4);

var $h8rc9 = parcelRequire("h8rc9");

var $kgK63 = parcelRequire("kgK63");

var $ZpNu1 = parcelRequire("ZpNu1");

var $cpZtx = parcelRequire("cpZtx");

var $8h9Pq = parcelRequire("8h9Pq");

var $dCaK4 = parcelRequire("dCaK4");

var $eIPA4 = parcelRequire("eIPA4");

var $77iOb = parcelRequire("77iOb");

var $jfq9O = parcelRequire("jfq9O");

var $hzJH3 = parcelRequire("hzJH3");

var $121DU = parcelRequire("121DU");
const $4e1a944052b5621b$export$89db4734f6c919c4 = async (serviceID, templateID, templateParams, options)=>{
    const opts = (0, $ZpNu1.buildOptions)(options);
    const publicKey = opts.publicKey || (0, $h8rc9.store).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $h8rc9.store).blockHeadless;
    const storageProvider = opts.storageProvider || (0, $h8rc9.store).storageProvider;
    const blockList = {
        ...(0, $h8rc9.store).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $h8rc9.store).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $dCaK4.isHeadless)(navigator)) return Promise.reject((0, $eIPA4.headlessError)());
    (0, $cpZtx.validateParams)(publicKey, serviceID, templateID);
    (0, $8h9Pq.validateTemplateParams)(templateParams);
    if (templateParams && (0, $77iOb.isBlockedValueInParams)(blockList, templateParams)) return Promise.reject((0, $jfq9O.blockedEmailError)());
    if (await (0, $hzJH3.isLimitRateHit)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $121DU.limitRateError)());
    const params = {
        lib_version: '4.4.1',
        user_id: publicKey,
        service_id: serviceID,
        template_id: templateID,
        template_params: templateParams
    };
    return (0, $kgK63.sendPost)('/api/v1.0/email/send', JSON.stringify(params), {
        'Content-type': 'application/json'
    });
};

});
parcelRegister("kgK63", function(module, exports) {

$parcel$export(module.exports, "sendPost", () => $ec190f1f3b1ae57b$export$4a68059d3a005c64);

var $4Fcgk = parcelRequire("4Fcgk");

var $h8rc9 = parcelRequire("h8rc9");
const $ec190f1f3b1ae57b$export$4a68059d3a005c64 = async (url, data, headers = {})=>{
    const response = await fetch((0, $h8rc9.store).origin + url, {
        method: 'POST',
        headers: headers,
        body: data
    });
    const message = await response.text();
    const responseStatus = new (0, $4Fcgk.EmailJSResponseStatus)(response.status, message);
    if (response.ok) return responseStatus;
    throw responseStatus;
};

});

parcelRegister("cpZtx", function(module, exports) {

$parcel$export(module.exports, "validateParams", () => $90a7819081cf59b4$export$1f3bf48e9edf7d72);
const $90a7819081cf59b4$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey || typeof publicKey !== 'string') throw 'The public key is required. Visit https://dashboard.emailjs.com/admin/account';
    if (!serviceID || typeof serviceID !== 'string') throw 'The service ID is required. Visit https://dashboard.emailjs.com/admin';
    if (!templateID || typeof templateID !== 'string') throw 'The template ID is required. Visit https://dashboard.emailjs.com/admin/templates';
};

});

parcelRegister("8h9Pq", function(module, exports) {

$parcel$export(module.exports, "validateTemplateParams", () => $606788fef0a93b78$export$80b670b04253020b);
const $606788fef0a93b78$export$80b670b04253020b = (templateParams)=>{
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (templateParams && templateParams.toString() !== '[object Object]') throw 'The template params have to be the object. Visit https://www.emailjs.com/docs/sdk/send/';
};

});

parcelRegister("dCaK4", function(module, exports) {

$parcel$export(module.exports, "isHeadless", () => $9e97281bc02a549f$export$b509da924d51a9a9);
const $9e97281bc02a549f$export$b509da924d51a9a9 = (navigator)=>{
    return navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
};

});

parcelRegister("eIPA4", function(module, exports) {

$parcel$export(module.exports, "headlessError", () => $ab7d2fa3f7df0c38$export$a8135c843594e85b);

var $4Fcgk = parcelRequire("4Fcgk");
const $ab7d2fa3f7df0c38$export$a8135c843594e85b = ()=>{
    return new (0, $4Fcgk.EmailJSResponseStatus)(451, 'Unavailable For Headless Browser');
};

});

parcelRegister("77iOb", function(module, exports) {

$parcel$export(module.exports, "isBlockedValueInParams", () => $52e7c6c8b64bb1c0$export$c7ab883573eb12a4);

var $iefjT = parcelRequire("iefjT");
const $52e7c6c8b64bb1c0$var$isBlockListDisabled = (options)=>{
    return !options.list?.length || !options.watchVariable;
};
const $52e7c6c8b64bb1c0$var$getValue = (data, name)=>{
    return data instanceof FormData ? data.get(name) : data[name];
};
const $52e7c6c8b64bb1c0$export$c7ab883573eb12a4 = (options, params)=>{
    if ($52e7c6c8b64bb1c0$var$isBlockListDisabled(options)) return false;
    (0, $iefjT.validateBlockListParams)(options.list, options.watchVariable);
    const value = $52e7c6c8b64bb1c0$var$getValue(params, options.watchVariable);
    if (typeof value !== 'string') return false;
    return options.list.includes(value);
};

});
parcelRegister("iefjT", function(module, exports) {

$parcel$export(module.exports, "validateBlockListParams", () => $d4556afef3d17824$export$1727dd877829fee8);
const $d4556afef3d17824$export$1727dd877829fee8 = (list, watchVariable)=>{
    if (!Array.isArray(list)) throw 'The BlockList list has to be an array';
    if (typeof watchVariable !== 'string') throw 'The BlockList watchVariable has to be a string';
};

});


parcelRegister("jfq9O", function(module, exports) {

$parcel$export(module.exports, "blockedEmailError", () => $e033b5517693ceb4$export$b30160cec00781e);

var $4Fcgk = parcelRequire("4Fcgk");
const $e033b5517693ceb4$export$b30160cec00781e = ()=>{
    return new (0, $4Fcgk.EmailJSResponseStatus)(403, 'Forbidden');
};

});

parcelRegister("hzJH3", function(module, exports) {

$parcel$export(module.exports, "isLimitRateHit", () => $ccb9264e82a8b92f$export$8b7f6a1a004faa27);

var $kKAN1 = parcelRequire("kKAN1");
const $ccb9264e82a8b92f$var$getLeftTime = async (id, throttle, storage)=>{
    const lastTime = Number(await storage.get(id) || 0);
    return throttle - Date.now() + lastTime;
};
const $ccb9264e82a8b92f$export$8b7f6a1a004faa27 = async (defaultID, options, storage)=>{
    if (!options.throttle || !storage) return false;
    (0, $kKAN1.validateLimitRateParams)(options.throttle, options.id);
    const id = options.id || defaultID;
    const leftTime = await $ccb9264e82a8b92f$var$getLeftTime(id, options.throttle, storage);
    if (leftTime > 0) return true;
    await storage.set(id, Date.now().toString());
    return false;
};

});
parcelRegister("kKAN1", function(module, exports) {

$parcel$export(module.exports, "validateLimitRateParams", () => $f1b4a42f5460eb37$export$88c64f8d5fea404b);
const $f1b4a42f5460eb37$export$88c64f8d5fea404b = (throttle, id)=>{
    if (typeof throttle !== 'number' || throttle < 0) throw 'The LimitRate throttle has to be a positive number';
    if (id && typeof id !== 'string') throw 'The LimitRate ID has to be a non-empty string';
};

});


parcelRegister("121DU", function(module, exports) {

$parcel$export(module.exports, "limitRateError", () => $0c0740911a700545$export$29b72785a20a20d9);

var $4Fcgk = parcelRequire("4Fcgk");
const $0c0740911a700545$export$29b72785a20a20d9 = ()=>{
    return new (0, $4Fcgk.EmailJSResponseStatus)(429, 'Too Many Requests');
};

});


parcelRegister("6nwiP", function(module, exports) {

$parcel$export(module.exports, "sendForm", () => $4a4df2b20f870b5d$export$c13a0f9407ffb567);

var $h8rc9 = parcelRequire("h8rc9");

var $kgK63 = parcelRequire("kgK63");

var $ZpNu1 = parcelRequire("ZpNu1");

var $lzbPB = parcelRequire("lzbPB");

var $cpZtx = parcelRequire("cpZtx");

var $dCaK4 = parcelRequire("dCaK4");

var $eIPA4 = parcelRequire("eIPA4");

var $77iOb = parcelRequire("77iOb");

var $jfq9O = parcelRequire("jfq9O");

var $hzJH3 = parcelRequire("hzJH3");

var $121DU = parcelRequire("121DU");
const $4a4df2b20f870b5d$var$findHTMLForm = (form)=>{
    return typeof form === 'string' ? document.querySelector(form) : form;
};
const $4a4df2b20f870b5d$export$c13a0f9407ffb567 = async (serviceID, templateID, form, options)=>{
    const opts = (0, $ZpNu1.buildOptions)(options);
    const publicKey = opts.publicKey || (0, $h8rc9.store).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $h8rc9.store).blockHeadless;
    const storageProvider = (0, $h8rc9.store).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $h8rc9.store).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $h8rc9.store).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $dCaK4.isHeadless)(navigator)) return Promise.reject((0, $eIPA4.headlessError)());
    const currentForm = $4a4df2b20f870b5d$var$findHTMLForm(form);
    (0, $cpZtx.validateParams)(publicKey, serviceID, templateID);
    (0, $lzbPB.validateForm)(currentForm);
    const formData = new FormData(currentForm);
    if ((0, $77iOb.isBlockedValueInParams)(blockList, formData)) return Promise.reject((0, $jfq9O.blockedEmailError)());
    if (await (0, $hzJH3.isLimitRateHit)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $121DU.limitRateError)());
    formData.append('lib_version', '4.4.1');
    formData.append('service_id', serviceID);
    formData.append('template_id', templateID);
    formData.append('user_id', publicKey);
    return (0, $kgK63.sendPost)('/api/v1.0/email/send-form', formData);
};

});
parcelRegister("lzbPB", function(module, exports) {

$parcel$export(module.exports, "validateForm", () => $fb360b4e9f3d39cc$export$ed692cabb252e59b);
const $fb360b4e9f3d39cc$export$ed692cabb252e59b = (form)=>{
    if (!form || form.nodeName !== 'FORM') throw 'The 3rd parameter is expected to be the HTML form element or the style selector of the form';
};

});



parcelRegister("2GcrT", function(module, exports) {
module.exports = import.meta.resolve("bA7tl");

});



//# sourceMappingURL=workspace.e021bdc9.js.map
